import { ALUMINIUM_KOZIJNEN, KUNSTSTOF_KOZIJNEN } from "./kozijnen";
import { ALUMINIUM_HEFSCHUIFPUI, ALUMINIUM_SCHUIFPUI, KUNSTSTOF_SCHUIFPUI, SCHUIFPUIEN } from "./schuifpuien";
import { ALUMINIUM_DEUREN, DEUREN, KUNSTSTOF_DEUREN } from "./deuren";
import { GEVELBEKLEDING, ROLLUIKEN, VELUX_DAKRAMEN } from "./aanvullend";

export const PRODUCT_PAGES = [
  KUNSTSTOF_KOZIJNEN, ALUMINIUM_KOZIJNEN,
  SCHUIFPUIEN, KUNSTSTOF_SCHUIFPUI, ALUMINIUM_SCHUIFPUI, ALUMINIUM_HEFSCHUIFPUI,
  DEUREN, KUNSTSTOF_DEUREN, ALUMINIUM_DEUREN,
  GEVELBEKLEDING, ROLLUIKEN, VELUX_DAKRAMEN,
];
